import React, { useEffect, useState } from "react";
import { FaInstagram, FaLinkedin } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const [isLargeScreen, setIsLargeScreen] = useState(
    () => window.matchMedia("(min-width: 1280px)").matches,
  );
  useEffect(() => {
    const mediaQuery = window.matchMedia("(min-width: 1280px)");
    const handleChange = (e) => setIsLargeScreen(e.matches);
    mediaQuery.addEventListener("change", handleChange);

    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);
  if (isLargeScreen) {
    return (
      <footer className="bg-dark-blue m-0 text-dark upy-2 upx-5 ">
        <div className="d-flex m-0 p-0 justify-content-between ">
          <div className="row m-0 p-0">
            <div className="col m-0 upx-2 ">
              <div className="m-0 p-0 uh-12 uw-28 d-flex align-items-center">
                <img
                  src="/RaycuraWhite.webp"
                  alt="Logo"
                  className="w-100 h-100 object-fit-contain"
                />
              </div>
              <p className="m-0 p-0 ufs-4 text-black">
                Innovating physiotherapy & orthopedics solutions, made with
                pride in India.
              </p>
              <div className="d-flex uw-20 uh-12 m-0 p-0 justify-content-between">
                <p className="m-0 p-0 ufs-4">
                  <a
                    href="https://www.instagram.com/raycura_medical_technologies?igsh=aHdubHFxOXhvcHhj"
                    className="text-white ufs-7 m-0 p-0"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaInstagram />
                  </a>
                </p>
                <p className="m-0 p-0 ufs-4">
                  <a
                    href="https://www.linkedin.com/company/raycura-medical-technologies/about/"
                    className="text-white ufs-7 m-0 p-0"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaLinkedin />
                  </a>
                </p>
              </div>
            </div>
            <div className="col m-0 upy-2">
              <p className="m-0 p-0 ufs-5 fw-bold">Our Products</p>
              <ul className="list-unstyled ufs-4 text-black">
                <li>Gamified Rehabilitation Device</li>
                <li>Digital Goniometer</li>
                <li>Intramedullary Bone Distraction Nail</li>
              </ul>
            </div>

            <div className="col m-0 upy-2">
              <p className="m-0 p-0 ufs-5 fw-bold">Quick Links</p>
              <ul className="list-unstyled m-0 p-0">
                <li
                  className="m-0 p-0 ufs-4 cursor-pointer text-black"
                  onClick={() => navigate("/")}
                >
                  Home
                </li>
                <li
                  className="m-0 p-0 ufs-4 cursor-pointer text-black"
                  onClick={() => navigate("/physio")}
                >
                  Physio
                </li>
                <li
                  className="m-0 p-0 ufs-4 cursor-pointer text-black"
                  onClick={() => navigate("/ortho")}
                >
                  Ortho
                </li>
                <li
                  className="m-0 p-0 ufs-4 cursor-pointer text-black"
                  onClick={() => navigate("/company")}
                >
                  Company
                </li>
                <li
                  className="m-0 p-0 ufs-4 cursor-pointer text-black"
                  onClick={() => navigate("/privacy")}
                >
                  Privacy Policy
                </li>
              </ul>
            </div>

            <div className="col m-0 upy-2">
              <p className="m-0 p-0 ufs-5 fw-bold">Contact Us</p>
              <p className="m-0 p-0 ufs-4">
                Renuka apartment, Plot no 79/80 Flat no 202, Swavalambi Nagar,
                Nagpur, Maharashtra 440022
              </p>
              <p className="m-0 p-0 ufs-4">
                <a
                  href="tel:+919876543210"
                  className="text-decoration-none text-black ufs-4 m-0 p-0"
                >
                  📞 +91 7028264636
                </a>
              </p>
              <p className="m-0 p-0 ufs-4">
                <a
                  href="mailto:mail@raycura.com"
                  className="text-decoration-none text-black ufs-4 m-0 p-0"
                >
                  ✉️ mail@raycura.com
                </a>
              </p>
              <p className="m-0 p-0 ufs-4">
                For sales and career inquiries, please contact us at
              </p>
              <p className="m-0 p-0 ufs-4">
                <a
                  href="mailto:mail@raycura.com"
                  className="text-decoration-none text-black ufs-4 m-0 p-0"
                >
                  ✉️ harshadvaidyaraycura@gmail.com
                </a>
              </p>
            </div>
          </div>
        </div>
        <div className="text-center ufs-4 uh-8 border-top ">
          <p>&copy; 2026 Raycura. All rights reserved.</p>
        </div>
      </footer>
    );
  } else {
    return (
      <footer className="bg-dark-blue m-0 text-dark upy-2 upx-5 ">
        <div className="d-flex m-0 p-0 w-100 justify-content-between ">
          <div className="row m-0 p-0">
            <div className="col-sm-12   m-0 p-0 ">
              <div className="m-0 p-0 uh-50 w-50 d-flex align-items-center">
                <img
                  src="/RaycuraWhite.webp"
                  alt="Logo"
                  className="w-100 h-100 object-fit-contain"
                />
              </div>
              <p className="m-0 upx-10 ufs-10 text-black">
                Innovating physiotherapy & orthopedics solutions, made with
                pride in India.
              </p>
              <div className="d-flex uh-50 uw-36 m-0 upx-10 justify-content-between">
                <p className="m-0 p-0 fs-1">
                  <a
                    href="https://www.instagram.com/raycura_medical_technologies?igsh=aHdubHFxOXhvcHhj"
                    className="text-white fs-1 fw-bold m-0 p-0"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaInstagram />
                  </a>
                </p>
                <p className="m-0 p-0 fs-1">
                  <a
                    href="https://www.linkedin.com/company/raycura-medical-technologies/about/"
                    className="text-white fs-1 fw-bold m-0 p-0"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaLinkedin />
                  </a>
                </p>
              </div>
            </div>
            <div className="col-sm-12  m-0 upx-10 ">
              <p className="m-0 p-0 ufs-10 fw-bold">Our Products</p>
              <ul className="list-unstyled ufs-9  m-0 p-0 text-black">
                <li>Gamified Rehabilitation Device</li>
                <li>Digital Goniometer</li>
                <li>Intramedullary Bone Distraction Nail</li>
              </ul>
            </div>

            <div className="col-sm-12 upx-10 m-0 py-0 ">
              <p className="m-0 p-0 ufs-10 fw-bold">Quick Links</p>
              <ul className="list-unstyled m-0 p-0">
                <li
                  className="m-0 p-0 ufs-9 cursor-pointer text-black"
                  onClick={() => navigate("/")}
                >
                  Home
                </li>
                <li
                  className="m-0 p-0 ufs-9 cursor-pointer text-black"
                  onClick={() => navigate("/physio")}
                >
                  Physio
                </li>
                <li
                  className="m-0 p-0 ufs-9 cursor-pointer text-black"
                  onClick={() => navigate("/ortho")}
                >
                  Ortho
                </li>
                <li
                  className="m-0 p-0 ufs-9 cursor-pointer text-black"
                  onClick={() => navigate("/company")}
                >
                  Company
                </li>
                <li
                  className="m-0 p-0 ufs-9 cursor-pointer text-black"
                  onClick={() => navigate("/privacy")}
                >
                  Privacy Policy
                </li>
              </ul>
            </div>

            <div className="col-sm-12 upx-10 m-0 upy-3">
              <p className="m-0 p-0 ufs-10 fw-bold">Contact Us</p>
              <p className="m-0 p-0 ufs-9">
                Renuka apartment, Plot no 79/80 Flat no 202, Swavalambi Nagar,
                Nagpur, Maharashtra 440022
              </p>
              <p className="m-0 p-0 ufs-9">
                <a
                  href="tel:+919876543210"
                  className="text-decoration-none text-black ufs-9 m-0 p-0"
                >
                  📞 +91 7028264636
                </a>
              </p>
              <p className="m-0 p-0 ufs-9">
                <a
                  href="mailto:mail@raycura.com"
                  className="text-decoration-none text-black ufs-9 m-0 p-0"
                >
                  ✉️ mail@raycura.com
                </a>
              </p>
              <p className="m-0 p-0 ufs-4">
                For sales and career inquiries, please contact us at
              </p>
              <p className="m-0 p-0 ufs-4">
                <a
                  href="mailto:mail@raycura.com"
                  className="text-decoration-none text-black ufs-4 m-0 p-0"
                >
                  ✉️ harshadvaidyaraycura@gmail.com
                </a>
              </p>
            </div>
          </div>
        </div>
        <div className="text-center ufs-9 bg-dark-blue border-top m-0 p-0 ">
          <p>&copy; 2026 Raycura. All rights reserved.</p>
        </div>
      </footer>
    );
  }
};

export default Footer;
